import { InvoiceDueDateSelect } from '@components';
import { L } from '@lib';
import { Customer, Invoice, Vehicle } from '@services';
import { Col, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import styled from 'styled-components';

const { Text } = Typography;

const ContainerWrapper = styled.div`
  background: #f0f7fb;
  width: 100%;
  padding: 12px 24px;
  border-radius: 10px;
`;

const VerticalGapRow = styled(Row)`
  margin-bottom: 5px;
`;
interface IProps {
  invoice?: Invoice;
  customer: Customer | undefined;
  registrationNumber: string | undefined;
  amount: number;
  dueDate: number;
  paymentTotal?: number;
  mileage?: number;
  vehicle: Vehicle | undefined;
  setDueDate?: (value: number) => void;
}

export const InvoiceHeaderDetails: React.FC<IProps> = ({
  invoice,
  dueDate,
  customer,
  registrationNumber,
  vehicle,
  mileage,
  setDueDate,
}) => {
  return (
    <ContainerWrapper>
      <VerticalGapRow gutter={8}>
        <Col span={12}>
          <Text strong>{L('Customer:')} </Text>
          <Text>{customer?.fullname}</Text>
        </Col>
        <Col span={12}>
          <Text strong>{L('Make:')} </Text>
          <Text>{vehicle?.combinedMake}</Text>
        </Col>
      </VerticalGapRow>
      <VerticalGapRow gutter={8}>
        <Col span={12}>
          <Text strong>{L('Vehicle:')} </Text>
          <Text>{registrationNumber}</Text>
        </Col>
        <Col span={12}>
          <Text strong>{L('Model:')} </Text>
          <Text>{vehicle?.combinedModel}</Text>
        </Col>
      </VerticalGapRow>
      <VerticalGapRow gutter={8}>
        <Col span={12}>
          <Text strong>{(invoice && L('Issued Date:')) || L('Date:')} </Text>
          {invoice
            ? dayjs(invoice.creationTime).format('DD/MM/YYYY')
            : dayjs(new Date()).format('DD/MM/YYYY')}
        </Col>
        <Col span={12}>
          <Text strong>{L('VIN number:')} </Text>
          <Text>{vehicle?.combinedVin}</Text>
        </Col>
      </VerticalGapRow>
      <VerticalGapRow gutter={8}>
        <Col span={12}>
          <Text strong>{L('Due Date:')} </Text>
          {invoice ? (
            <Text>
              {dayjs(invoice.creationTime).add(invoice.dueDate, 'd').format('DD/MM/YYYY')}
            </Text>
          ) : (
            <InvoiceDueDateSelect value={dueDate} onChange={setDueDate} />
          )}
        </Col>
        <Col span={12}>
          <Text strong>{L('Mileage:')} </Text>
          <Text>{mileage}</Text>
        </Col>
      </VerticalGapRow>
    </ContainerWrapper>
  );
};
